import React from "react";
import { IoIosHelpCircleOutline } from "react-icons/io";
import { ReservationConfig } from "../../../models/ReservationConfig";
import {
  GDANSK_KIND_BASIC_PASS,
  GDANSK_KIND_BEARER_PASS,
  GDANSK_KIND_PASS_OPEN,
  GDANSK_KIND_SINGLE_TICKET,
  GDANSK_KIND_SWIMMING_TRACK,
} from "../Steps/gdanskSaleStepsConsts";

interface IProps {
  value: string;
  reservationConfig: ReservationConfig;
}

const ProductTypeInfo: React.FC<IProps> = ({ value, reservationConfig }) => {
  let description = "";

  switch (value) {
    case GDANSK_KIND_SINGLE_TICKET:
      description = reservationConfig.singleTicketDescription;
      break;
    case GDANSK_KIND_BASIC_PASS:
      description = reservationConfig.basicPassDescription;
      break;
    case GDANSK_KIND_BEARER_PASS:
      description = reservationConfig.bearerPassDescription;
      break;
    case GDANSK_KIND_SWIMMING_TRACK:
      description = reservationConfig.swimmingTracksDescription;
      break;
    case GDANSK_KIND_PASS_OPEN:
      description = reservationConfig.passDescription;
      break;
    default:
      description = "";
  }

  if (!description) {
    return null;
  }

  return (
    <div className="product-type-info">
      <span className="body-text-small">
        <IoIosHelpCircleOutline /> Objaśnienie
      </span>
      <br />
      <span className="caption">{description}</span>
    </div>
  );
};

export default ProductTypeInfo;
